import React from 'react';
import get from 'lodash/get';
import ChipList from 'components/ChipList';
import Chip from 'components/Chip';
import { SkeletonLine } from 'components/theme/Skeleton';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MainTitle } from 'components/theme/Typography/Typography';
import {
  ExperiencesHeaderContent,
  BrandName,
  Headline,
  TagButtonWrap,
  CategoryChip,
} from './styles';

interface MainTitlesProps {
  promoterBrand: boolean;
}

export const MainTitles = styled(MainTitle)<MainTitlesProps>`
  margin-bottom: ${({ promoterBrand }) => (promoterBrand ? '12px' : '20px')};
  font-size: 36px;
  line-height: 44px;
  @media (min-width: 768px) {
    margin-top: 10px;
    font-size: 36px;
    line-height: 44px;
  }
`;

interface Vibe {
  name: string;
}

interface Category {
  name: string;
}

interface IExperience {
  title?: string;
  headline?: string;
  loading: boolean;
  category?: Category;
  vibes?: Vibe[];
  sessionDurationMinutes?: number;
  maxParticipantsCount?: number;
  location?: {
    name?: string;
  };
}

interface ExperienceHeaderProps {
  experience: IExperience;
  isLoadingBrand: boolean;
  isLoadingListing: boolean;
  promoterBrand: string;
}

const ExperienceHeader: React.FC<ExperienceHeaderProps> = ({
  experience,
  isLoadingBrand,
  isLoadingListing,
  promoterBrand,
}) => {
  const { t: translate } = useTranslation();

  return (
    <ExperiencesHeaderContent>
      {!experience.loading || !isLoadingListing ? (
        <MainTitles
          as={'h1' as const}
          className="experience-view-title"
          promoterBrand={!!promoterBrand}
        >
          {experience?.title}
        </MainTitles>
      ) : (
        <SkeletonLine />
      )}

      {(!experience.loading || !isLoadingListing || !isLoadingBrand) &&
        promoterBrand && (
          <BrandName>
            {translate('by')} {promoterBrand}
          </BrandName>
        )}

      {!experience.loading || !isLoadingListing ? (
        <Headline className="experience-view-headline">
          {experience?.headline}
        </Headline>
      ) : (
        <SkeletonLine />
      )}

      <TagButtonWrap
        className="experience-view__tag-buttons-container"
        aria-label="Experience tags"
      >
        {!experience.loading ? (
          <ChipList className="experience-view__category-button-container">
            <CategoryChip as="li" className="experience-view__category-button">
              {get(experience, 'category.name')}
            </CategoryChip>
            {experience?.vibes?.map((vibe: Vibe) => (
              <Chip as="li" key={vibe.name} className="experience-view__vibe">
                {vibe.name}
              </Chip>
            ))}
          </ChipList>
        ) : (
          <SkeletonLine />
        )}
      </TagButtonWrap>
    </ExperiencesHeaderContent>
  );
};

export default ExperienceHeader;
